import { render, staticRenderFns } from "./consult-manage.vue?vue&type=template&id=5f0ee9a4&scoped=true&"
import script from "./consult-manage.vue?vue&type=script&lang=ts&"
export * from "./consult-manage.vue?vue&type=script&lang=ts&"
import style0 from "./consult-manage.vue?vue&type=style&index=0&id=5f0ee9a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0ee9a4",
  null
  
)

export default component.exports